import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES, ANZ_COUNTRIES, NON_EU_AND_ITALY, RESTRICTED_COUNTRIES_TOS, getLanguageAndCountrySpecificLink } from "@faire/retailer-visitor-shared/lib/localization";
import { TOSType, TOSCountryType } from "@faire/retailer-visitor-shared/views/terms-of-services/data/consts";
import { chooseArticleId } from "@faire/retailer-visitor-shared/views/terms-of-services/data/utils";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
export var getBrandTOSArticleData = function() {
    // Because of SOYO portugal needs to be different only for brand TOS
    var ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES_WITHOUT_PORTUGAL = ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES.filter(function(i) {
        return i !== ISO3166Alpha3.PRT;
    });
    var _obj;
    return getLanguageAndCountrySpecificLink((_obj = {}, _define_property(_obj, Language.DEU, [
        {
            restrictedCountries: RESTRICTED_COUNTRIES_TOS,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _define_property(_obj, Language.FRA, [
        {
            countries: [
                ISO3166Alpha3.CAN
            ],
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.CAN)
        },
        {
            restrictedCountries: RESTRICTED_COUNTRIES_TOS,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _define_property(_obj, Language.ENG, [
        {
            restrictedCountries: NON_EU_AND_ITALY,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        },
        {
            countries: [
                ISO3166Alpha3.ITA
            ],
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.ITA)
        },
        {
            countries: ANZ_COUNTRIES,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.ANZ)
        }
    ]), _define_property(_obj, Language.SPA, [
        {
            restrictedCountries: RESTRICTED_COUNTRIES_TOS,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _define_property(_obj, Language.ITA, [
        {
            countries: [
                ISO3166Alpha3.ITA
            ],
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.ITA)
        }
    ]), _define_property(_obj, Language.DAN, [
        {
            countries: ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES_WITHOUT_PORTUGAL,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _define_property(_obj, Language.SWE, [
        {
            countries: ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES_WITHOUT_PORTUGAL,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _define_property(_obj, Language.POR, [
        {
            countries: [
                ISO3166Alpha3.PRT
            ],
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _define_property(_obj, Language.NLD, [
        {
            restrictedCountries: RESTRICTED_COUNTRIES_TOS,
            link: chooseArticleId(TOSType.BRAND, TOSCountryType.EU_GENERAL)
        }
    ]), _obj), {
        linkOrId: chooseArticleId(TOSType.BRAND, TOSCountryType.USA),
        locale: Language.ENG
    });
};
